/**
 * 🏗 Model used for storing the needed properties for the general message
 */
export default class GeneralMessageModel {
  public title: string;
  public message?: string;
  public buttonText: string | undefined;
  public buttonClickRoute: string | undefined;

  constructor(
    title: string,
    message?: string,
    buttonText?: string,
    buttonClickRoute?: string
  ) {
    this.title = title;
    this.message = message;
    this.buttonText = buttonText;
    this.buttonClickRoute = buttonClickRoute;
  }
}